import { getApps, initializeApp } from 'firebase/app'
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  type Auth,
} from 'firebase/auth'

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const isFirebaseConfigured = Object.values(config).every(Boolean)

const app = isFirebaseConfigured
  ? (getApps()[0] ?? initializeApp(config))
  : null

export const firebaseAuth: Auth | null = app ? getAuth(app) : null
export const googleAuthProvider = new GoogleAuthProvider()
googleAuthProvider.setCustomParameters({ prompt: 'select_account' })

export async function enablePersistentAuth(): Promise<void> {
  if (firebaseAuth) await setPersistence(firebaseAuth, browserLocalPersistence)
}
